import * as Sentry from '@sentry/react';

function sentryCapture(error: unknown, context?: string): void {
  Sentry.addBreadcrumb({
    category: 'error',
    message: context ?? (error instanceof Error ? error.message : String(error)),
    level: 'error',
  });

  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext('errorContext', { context });
    }

    if (error instanceof Error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureMessage(String(error));
    }
  });
}

/**
 * Captures an error to both console and Sentry.
 * Use this instead of console.error for errors you want to report to Sentry.
 */
export function captureError(error: unknown, context?: string): void {
  if (context) {
    console.error(context, error);
  } else {
    console.error(error);
  }

  sentryCapture(error, context);
}

/**
 * Captures an error to Sentry only (no console output).
 * Use this for production-only error reporting.
 */
export function captureErrorSilently(error: unknown, context?: string): void {
  sentryCapture(error, context);
}
